module.exports = __webpack_public_path__ + "static/media/tj.88ea306f.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/tj.svg
// module id = 955
// module chunks = 0